export function getRowKey(record: any): any {
  return record.key ?? record.id;
}

export function onHeaderCell(record: any): any {
  return {
    record,
    style: { background: '#91d5ff' }
  };
}

export const fakeTotal = (pageNumber: number, pageSize: number, currentLength: number) => {
  if (pageNumber === 1 && currentLength === 0) {
    return 0;
  }

  const totalBefore = pageSize * (pageNumber - 1);
  if (currentLength < pageSize) {
    if (currentLength < 1) {
      return totalBefore + 1;
    }
    return totalBefore + currentLength;
  }

  return totalBefore + pageSize + 1;
};

export const getCellData = (col, record, index, defaultValue = '') => {
  if (!col || !record) {
    return defaultValue;
  }

  const params = {
    value: col.dataIndex ? record[col.dataIndex] : record,
    record: record,
    index: index
  };

  if (typeof col.renderExport === 'function') {
    return col.renderExport(params.value, params.record, params.index);
  }

  if (typeof col.render === 'function') {
    return col.render(params.value, params.record, params.index);
  }

  if (col.dataIndex) {
    return record[col.dataIndex];
  }

  if (col.key) {
    return record[col.key];
  }

  return defaultValue;
};

export const getColumnTitle = (col, defaultValue = '') => {
  if (!col) {
    return defaultValue;
  }

  if (col.titleExport) {
    return col.titleExport;
  }

  if (col.title) {
    return col.title;
  }

  return defaultValue;
};
